import { addMethod, object, ValidationError } from 'yup';

addMethod(object, 'minTournamentPlayers', function (minPlayersAmount: number, message: string) {
  return this.test('minTournamentPlayers', function (value = { teamSize: 0, minTeams: 0 }) {
    const { teamSize, minTeams } = value;
    const isValid = teamSize * minTeams >= minPlayersAmount;

    if (!isValid) {
      const errors = [
        this.createError({ path: `${this.path}.teamSize`, message: message }),
        this.createError({ path: `${this.path}.minTeams`, message: message }),
      ];

      return new ValidationError(errors);
    }

    return isValid;
  });
});
